import React from 'react';
import { Card, Progress, Typography, Empty } from 'antd';
import { AnaliseTemporal } from '../../../types/dashboard/csa.types';

const { Text } = Typography;

interface CSATimelineChartProps {
  data: AnaliseTemporal[];
  loading?: boolean;
}

const CSATimelineChart: React.FC<CSATimelineChartProps> = ({ 
  data, 
  loading = false 
}) => {
  if (!data || data.length === 0) {
    return (
      <Card title="Análise Temporal" size="small" loading={loading}>
        <Empty description="Nenhum dado disponível" />
      </Card>
    );
  }

  const maxValue = Math.max(...data.map(item => item.count));

  return (
    <Card title="Análise Temporal" size="small" loading={loading}>
      <div style={{ padding: '16px 0' }}>
        {data.map((item, index) => (
          <div key={index} style={{ marginBottom: 16 }}>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              marginBottom: 4 
            }}>
              <Text strong>{item.periodo}</Text>
              <Text>{item.count} vulnerabilidades</Text>
            </div>
            <Progress 
              percent={maxValue > 0 ? (item.count / maxValue) * 100 : 0} 
              strokeColor="#1890ff"
              showInfo={false}
              size="small"
            />
          </div>
        ))}
      </div>
    </Card>
  );
};

export default CSATimelineChart;